import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _readOnlyError from "@babel/runtime/helpers/readOnlyError";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["render", "Loader", "ErrorFallback", "renderDefaultErrorFallback", "loading"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { PrimaryButton } from '@crehana/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LOCALES = {
  es: {
    INTERNET_CONNECTION_ERROR: 'Ocurrió un error de conexión',
    RELOAD_PAGE: 'Recargar la página'
  },
  pt: {
    INTERNET_CONNECTION_ERROR: 'Ocorreu um erro de conexão',
    RELOAD_PAGE: 'Recarregue a página'
  }
};

// TODO: Use a function to get the countryPrefix
var STRINGS = LOCALES.es;
// biome-ignore lint/complexity/noBannedTypes: legacy type usage
var Loadable = /*#__PURE__*/function (_Component) {
  function Loadable(props) {
    var _this;
    _classCallCheck(this, Loadable);
    _this = _callSuper(this, Loadable, [props]);
    _this.state = {
      LoadableComponent: undefined,
      pastDelay: typeof _this.props.delay === 'undefined',
      error: false
    };
    return _this;
  }
  _inherits(Loadable, _Component);
  return _createClass(Loadable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var delay = this.props.delay;
      if (delay) {
        setTimeout(function () {
          _this2.setState({
            pastDelay: true
          });
        }, delay);
      }
      this.props.module().then(function (Cmp) {
        _this2.setState({
          LoadableComponent: Cmp["default"]
        });
      })["catch"](function (e) {
        _this2.setState({
          error: true
        });
        // don't use console.log because it is removed at compilation time
        console.error('Error to load the chunk', e);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        LoadableComponent = _this$state.LoadableComponent,
        pastDelay = _this$state.pastDelay,
        error = _this$state.error;
      // just spread module to not passed it with the rest of props

      var _this$props = this.props,
        render = _this$props.render,
        Loader = _this$props.Loader,
        ErrorFallback = _this$props.ErrorFallback,
        renderDefaultErrorFallback = _this$props.renderDefaultErrorFallback,
        loading = _this$props.loading,
        rest = _objectWithoutProperties(_this$props, _excluded);
      if (error) {
        if (ErrorFallback || renderDefaultErrorFallback) {
          return ErrorFallback || /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col items-center w-full p-16 text-center bg-base-lighter-16 sm:p-32",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "mb-16 font-subtitle2",
              children: STRINGS.INTERNET_CONNECTION_ERROR
            }), /*#__PURE__*/_jsx(PrimaryButton, {
              className: "w-full sm:w-auto",
              label: STRINGS.RELOAD_PAGE,
              onClick: function onClick() {
                window.location.reload();
              }
            })]
          });
        }
        return null;
      }
      if (!pastDelay || loading || !LoadableComponent) {
        return Loader || null;
      }
      if (LoadableComponent) {
        if (render) {
          return render(LoadableComponent);
        }
        return /*#__PURE__*/_jsx(LoadableComponent, _objectSpread({}, rest));
      }
      return null;
    }
  }]);
}(Component);
Loadable.defaultProps = {
  loading: false
};
export default Loadable;